import React from 'react';
import PropTypes from 'prop-types';
import questionCss from './Questions.scss'
import css from './ShortTextField.scss'
import Icon from 'SF/MaterialIcon';
import Input from './Input';
import { omit, isNaN } from 'lodash'

export default class NumberField extends React.Component {

  focusOutHandler = (e) => { 
    if(e.target.value !== null ){
      const value = parseFloat(e.target.value); 
      if(!isNaN(value) && Math.round(value) !== value)
        this.props.setValue(Number(value.toFixed(2)));
    }
  } 

  getEditableField = (inputProps, questionText) => {
    const { value } = inputProps
    return (
      <Input
          {...omit(inputProps, 'setValue', 'setHasError', 'questionNumber')}
          type="text" 
          inputMode="decimal"
          aria-label={questionText} 
          value={value !== null ? value : ''}
          onChange={this.changeHandler}
          onBlur={this.focusOutHandler}
        />
    );
  }

  renderEmptyAnswerBlock = () => {
    return (
      <i>No answer provided</i>
    );
  }

  getReadOnlyField = (value) => {
    return (
      <p className={css['number-input-answers']}>{value !== null ? value : this.renderEmptyAnswerBlock()}</p>
    );
  }

  changeHandler = (e) => {
    /* Validation Regex to achieve the following constraints, 
     *  Only one - is allowed as prefix
     *  Only one . is allowed on entire value */
    const validNumberRegex = new RegExp("^-?[0-9]*(\\.[0-9]*)?$");
    const value = e.target.value;
    if(value === ''){
      this.props.setValue(null);
      return;
    }
    if(validNumberRegex.test(value)){
      this.props.setValue(value)
    }
  }

  render() {
    const { isReadOnly, hasError, questionText, ...rest } = this.props;
    const questionErrorClassName = hasError ? css['error'] : '';
    return (
      <>
        <div className={`${questionErrorClassName}`}>
          {isReadOnly ? this.getReadOnlyField(rest.value) : this.getEditableField(rest, questionText)}
        </div>
        {!isReadOnly && hasError && (
          <div className={questionCss['input-error-message-block']} role="alert">
            <Icon icon="error" /><p>Only numbers are accepted</p>
          </div>
        )}
      </>
    );
  }
}

NumberField.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  questionText: PropTypes.string,
  isReadOnly: PropTypes.bool,
  hasError: PropTypes.bool,
  setValue: PropTypes.func
}
